import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AppointmentDialogDataV2Model} from '../models/edit-appoitment-data-model';
import {SchedulerService} from '../scheduler.service';
import {Globals} from '../../../globals';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {MatSnackBar} from "@angular/material/snack-bar";
//import {TdoEnumSelectComponent} from 'TdoEnumSelectComponent'


@Component({
    selector: 'app-edit-appointment-select-procedure-dialog',
    templateUrl: './edit-appointment-select-procedure-dialog.component.html',
    styleUrls: ['./edit-appointment-select-procedure-dialog.component.scss']
})
export class EditAppointmentSelectProcedureDialogComponent implements OnInit {

    patientCases: any[];
    caseProcedures: any[];
    patientCaseProcedures: any[] =[];

    tabSelectedIndex: number = 0;

    selectedCase: any;

    selectedNewAppCaseProcedureID: string  ;
    selectExstPatientCaseId : string ;
    selectExstCaseWorkItemId: string ;
    selectExstProcedureName: string ;

    selectEnumCaseFollowupReasonID: string ;
    selectEnumCaseFollowupReason: string ;


    constructor( @Inject(MAT_DIALOG_DATA) public data: AppointmentDialogDataV2Model,
                 private dialogRef: MatDialogRef<EditAppointmentSelectProcedureDialogComponent>,
                 private schedulingService: SchedulerService,
                 private snackBar: MatSnackBar,

    ) {  }


    ngOnInit() {
        console.log('data: ', this.data);


      this.selectEnumCaseFollowupReasonID= '';
      this.selectEnumCaseFollowupReason='';

        // load patient cases
        this.patientCases = [];

        this.schedulingService.getAllPatientCases( this.data.appointment.PatientId ).subscribe(res => {


            const z = JSON.parse(res);

            this.patientCases = z.retcase;
            this.caseProcedures = z.retproc;

            if (this.patientCases.length > 0 ) {
                this.selectedCase = this.patientCases[0];
            }


        });




    }

  onProcSelectionChanged(e: any ) {

    this.selectedNewAppCaseProcedureID = e.addedItems[0].CaseProcedureId;
    this.selectExstProcedureName = e.addedItems[0].ProcedureName;
      //console.log(e.addedItems[0].CaseProcedureId);
      //console.log(e.addedItems[0].ProcedureName);

  }


  selectedTooth ="";
  onCaseSelectionChanged(e: any) {
      // filter ARRY FOR CASE PROCEURES

    //console.log('case: ', e.addedItems[0].PatientCaseID , this.caseProcedures);

    this.selectedTooth= e.addedItems[0].Teeth;

    this.patientCaseProcedures = this.caseProcedures.filter(f => f.PatientCaseId === e.addedItems[0].PatientCaseID);

    console.log('sort',this.patientCaseProcedures );


    this.selectExstPatientCaseId = undefined;
    this.selectExstCaseWorkItemId = undefined;

    //console.log('case: ', e.addedItems[0].PatientCaseID , this.patientCaseProcedures);


  }

  onCaseProcSelectionChanged(e : any)  {

    //console.log(e.addedItems[0].CaseProcedureId);  CaseWorkItemId

    this.selectExstPatientCaseId =e.addedItems[0].PatientCaseId;
    this.selectExstCaseWorkItemId = e.addedItems[0].CaseWorkItemId ;
    this.selectExstProcedureName = e.addedItems[0].ProcedureName;




  }

    tabChanged(tabChangeEvent: MatTabChangeEvent) {
        this.tabSelectedIndex = tabChangeEvent.index;
    }




    onOkClick() {

        switch (this.tabSelectedIndex)
        {
        case 0:
            const ret =  {"type": "new", "CaseProcedureID": this.selectedNewAppCaseProcedureID, "ProcedureName": this.selectExstProcedureName};
            //console.log('Tab: new Appoitment ', ret);
            // procList
            this.dialogRef.close(ret);
            break;
        case 1:
            if( this.selectExstPatientCaseId == undefined || this.selectExstCaseWorkItemId ==undefined )
            {

              this.snackBar.open("Please select Case and Proceure !", "Error" , {
                duration: 3000,
                verticalPosition: 'top'
              });
             break;
            }




            const retp  =  {"type": "case", "PatientCaseId": this.selectExstPatientCaseId, "CaseWorkItemId": this.selectExstCaseWorkItemId, "ProcedureName": this.selectExstProcedureName, "EnumCaseFollowupReason":  '#'+this.selectedTooth+ ' '+ this.selectEnumCaseFollowupReason};
            //console.log('Tab: existin case ', retp);

            this.dialogRef.close(retp);
            break;

        default:
          //
          this.dialogRef.close(true);

        }







    }
    onCancelClick()  {

      const ret =  {"type": "cancel"};
      this.dialogRef.close(ret);
    }


  onDropdownItemSelected(e) {

    this.selectEnumCaseFollowupReason =  e.ItemDisplayValue;

    console.log('Selected: ', this.selectEnumCaseFollowupReason );

  }

}
